import styled from 'styled-components';

export const Input = styled.input`
  max-width: 100%;
  flex: 1 0 auto;
  outline: 0;
  text-align: left;
  line-height: 19.4px;
  font-family: Lato, 'Helvetica Neue', Arial, Helvetica, sans-serif;
  padding: 10.8px 16px;
  background: #fff;
  border: 1px solid rgba(34, 36, 38, 0.15);
  color: rgba(0, 0, 0, 0.87);
  border-radius: 4px;
  transition:
    box-shadow 0.1s ease,
    border-color 0.1s ease,
    -webkit-box-shadow 0.1s ease;
  box-shadow: none;

  &.is-error {
    background: #fff6f6;
    border-color: #e0b4b4;
    color: #9f3a38;
    box-shadow: none;
  }
`;
